<template>
  <div class="div" v-loading="loading">
    <div class="div-center">
      <el-tabs
        v-model="activeName"
        type="card"
        style="height: 100%"
        @tab-click="tabClick"
      >
        <el-tab-pane label="运维数据分析" name="CostEcharts">
          <div class="div-top">
            <el-date-picker
              v-model="searchYear"
              type="year"
              value-format="yyyy"
              @change="getEchartsData"
              placeholder="选择年"
            >
            </el-date-picker>
          </div>
          <!-- 柱状图卡片（先显示） -->
          <el-card
            class="chart-card"
            header="各月运维总成本"
            style="margin-bottom: 16px"
          >
            <div class="tab-chart-container"></div>
          </el-card>
          <!-- 饼图卡片（后显示） -->
          <el-card class="chart-card" header="各月成本分布">
            <div class="tab-chart-pieList">
              <div class="pie-charts-container">
                <div
                  v-for="(month, index) in monthChartData"
                  :key="month.name"
                  :id="`pie-chart-${index}`"
                  class="pie-chart-item"
                ></div>
              </div>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="运维成本" name="Cost">
          <div class="div-top">
            <el-date-picker
              v-model="searchYearMonth"
              type="monthrange"
              value-format="yyyyMM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :clearable="false"
            >
            </el-date-picker>
            <el-button
              type="primary"
              @click="handleSearch"
              style="margin-left: 10px"
              >查询</el-button
            >
            <el-button
              type="warning"
              @click="handleExport"
              style="margin-left: 10px"
              icon="el-icon-download"
              >导出数据</el-button
            >
          </div>
          <!-- show-summary
            :summary-method="getSummaries" -->
          <el-table
            :key="tableKey"
            :data="tableData"
            ref="table"
            style="width: 100%"
            height="calc(100% - 90px)"
          >
            <el-table-column
              label="设备分类"
              align="center"
              prop="DeviceTypeName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备编号"
              align="center"
              prop="DeviceCode"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备名称"
              align="center"
              prop="DeviceName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="年月"
              align="center"
              prop="iYearMonth"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="安装位置"
              align="center"
              prop="Position"
              sortable
            >
            </el-table-column>
            <el-table-column label="能耗" align="center">
              <el-table-column
                label="电"
                align="right"
                prop="ElectricityAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.ElectricityAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="水"
                align="right"
                prop="WaterAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.WaterAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="气"
                align="right"
                prop="GasAmount"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.GasAmount, 2) }}
                </template>
              </el-table-column>
              <el-table-column
                label="小计"
                align="right"
                prop="SubTotal"
                sortable
              >
                <template slot-scope="scope">
                  {{ $tools.momenyFormat(scope.row.SubTotal, 2) }}
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="机物料摊销"
              align="right"
              prop="AmortizationAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.AmortizationAmount, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              label="外委维修"
              align="right"
              prop="OutsourcingAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.OutsourcingAmount, 2) }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="折旧"
              align="center"
              prop="DeviceDepreciationAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.DeviceDepreciationAmount, 2) }}
              </template>
            </el-table-column> -->
            <el-table-column
              label="总计"
              align="right"
              prop="ToTalAmount"
              sortable
            >
              <template slot-scope="scope">
                {{ $tools.momenyFormat(scope.row.ToTalAmount, 2) }}
              </template>
            </el-table-column>
          </el-table>

          <!-- 总计行 -->
          <!-- <div class="custom-subtotal-row" v-if="tableData.length">
            <span class="subtotal-cell" style="width: 120px">小计</span>
            <span class="subtotal-cell" style="width: 120px"></span>
            <span class="subtotal-cell" style="width: 120px"></span>
            <span class="subtotal-cell" style="width: 120px"></span>
            <span class="subtotal-cell" style="width: 120px"></span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("ElectricityAmount"), 2) }}
            </span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("WaterAmount"), 2) }}
            </span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("GasAmount"), 2) }}
            </span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("SubTotal"), 2) }}
            </span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("AmortizationAmount"), 2) }}
            </span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("OutsourcingAmount"), 2) }}
            </span>
            <span class="subtotal-cell" style="width: 120px; text-align: right">
              {{ $tools.momenyFormat(getSubtotal("ToTalAmount"), 2) }}
            </span>
          </div> -->

          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.PageSizes"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
import moment from 'moment'
import * as echarts from 'echarts'
export default {
  data() {
    return {
      tools,
      searchYearMonth: [],
      searchYear: '',
      tableData: [],
      chartData: [],
      monthChartData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      activeName: 'CostEcharts',
      tableKey: 0,
    }
  },
  props: {},
  components: {},
  methods: {
    tabClick(tab) {
      this.activeName = tab.name
      this.chartData = []
      if (this.activeName === 'CostEcharts') {
        this.getEchartsData()
      } else {
        this.getDataList()
      }
      this.tableKey += 1
    },
    handleExport() {
      // 可根据需要补充导出逻辑

      if (this.searchYearMonth && this.searchYearMonth.length > 0) {
        tools.download(
          this.$rootUrl +
            `/Base_DeviceTreeManage/Device/OperationCostExportToExcel?DeviceType=${
              this.devTreeSearch.DeviceType || ''
            }&BuildingId=${
              this.devTreeSearch.BuildingId || ''
            }&InstallationArea=${
              this.devTreeSearch.InstallationArea || ''
            }&isYearMonth=${this.searchYearMonth[0] || ''}&ieYearMonth=${
              this.searchYearMonth[1] || ''
            }`,
          '运维成本分析',
          '.xlsx',
          'get'
        )
      } else {
        return this.$notify.warning('请选择年月后导出')
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    fun(val) {
      return '折旧总金额：' + (Number(val) === 0 ? 0 : Number(val).toFixed(2))
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device/GetDeviceOperationCostDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'Id',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceType',
              Keyword: this.devTreeSearch.DeviceType || '',
            },
            {
              Condition: 'BuildingId',
              Keyword: this.devTreeSearch.BuildingId || '',
            },
            {
              Condition: 'InstallationArea',
              Keyword: this.devTreeSearch.InstallationArea || '',
            },
            {
              Condition: 'isYearMonth',
              Keyword: this.searchYearMonth ? this.searchYearMonth[0] : '',
            },
            {
              Condition: 'ieYearMonth',
              Keyword: this.searchYearMonth ? this.searchYearMonth[1] : '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
              this.tableKey += 1
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    getEchartsData() {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/Device/GetDeviceOperationCostDataListAnalysis',
          {
            Search: [
              {
                Condition: 'DeviceType',
                Keyword: this.devTreeSearch.DeviceType || '',
              },
              {
                Condition: 'BuildingId',
                Keyword: this.devTreeSearch.BuildingId || '',
              },
              {
                Condition: 'InstallationArea',
                Keyword: this.devTreeSearch.InstallationArea || '',
              },

              {
                Condition: 'YearMonth',
                Keyword: this.searchYear,
              },
            ],
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.monthChartData = res.Data.monthlist || []
            this.chartData = res.Data.list || []
            this.$nextTick(() => {
              this.renderEcharts()
              this.renderPieCharts()
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    renderEcharts() {
      const dom = document.querySelector('.tab-chart-container')
      if (!dom) return
      if (dom.__echarts__) dom.__echarts__.dispose()
      const myChart = echarts.init(dom)
      const option = {
        tooltip: {
          formatter: (params) => {
            return `${
              params.seriesName
            }<br/><span style="width:10px;height:10px;display:inline-block;background-color:${
              params.color
            };border-radius:50%;margin-right:5px"></span>${
              params.name
            }<span style="font-weight:bold;margin-left:10px">${this.$tools.momenyFormat(
              params.value,
              2
            )}</span>`
          },
        },
        grid: { left: 60, top: 60, right: 40, bottom: 40 },
        xAxis: {
          type: 'category',
          data: this.chartData.map((i) => i.name),
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: '运维成本',
            type: 'bar',
            data: this.chartData.map((i) => i.value),
            label: {
              show: true,
              formatter: (params) =>
                params.value === 0
                  ? ''
                  : this.$tools.momenyFormat(params.value, 2),
            },
            itemStyle: {
              color: function (params) {
                const colors = [
                  '#5470C6',
                  '#91CC75',
                  '#EE6666',
                  '#FAC858',
                  '#73C0DE',
                  '#3BA272',
                  '#FC8452',
                  '#9A60B4',
                  '#EA7CCC',
                  '#FF9F7F',
                  '#B6A2DE',
                  '#2EC7C9',
                  '#B7A2DE',
                  '#FFB980',
                  '#5AB1EF',
                ]
                return colors[params.dataIndex % colors.length]
              },
            },
          },
        ],
      }
      myChart.setOption(option)
    },
    renderPieCharts() {
      // 销毁所有已存在的饼图实例
      this.monthChartData.forEach((_, index) => {
        const dom = document.getElementById(`pie-chart-${index}`)
        if (dom && dom.__echarts__) {
          dom.__echarts__.dispose()
        }
      })

      // 渲染每个月的饼图
      this.monthChartData.forEach((month, index) => {
        const dom = document.getElementById(`pie-chart-${index}`)
        if (!dom) return

        // 判断数据是否全为0或空
        const isAllZeroOrEmpty =
          !month.value ||
          month.value.length === 0 ||
          month.value.every((item) => !item.value || Number(item.value) === 0)

        // 不再显示el-empty或暂无数据，始终渲染ECharts
        const myChart = echarts.init(dom)

        const option = {
          title: {
            text: month.name,
            left: 'center',
            top: 20,
            textStyle: {
              fontSize: 12,
              fontWeight: 'bold',
            },
          },
          tooltip: {
            trigger: 'item',
            position: 'top',
            formatter: (params) => {
              // value为0或空时不显示label
              if (!params.value || Number(params.value) === 0) return ''
              return `${params.name}: ${this.$tools.momenyFormat(
                params.value,
                2
              )} (${params.percent}%)`
            },
          },
          legend: {
            type: 'scroll',
            left: 'center',
            itemWidth: 14,
            show: false,
          },
          series: [
            {
              name: '成本分布',
              type: 'pie',
              radius: '60%',
              center: ['50%', '60%'],
              data: isAllZeroOrEmpty
                ? []
                : month.value.map((item) => ({
                    name: item.name,
                    value: item.value,
                  })),
              labelLine: {
                show: true,
                length: 1,
                length2: 1,
              },
              label: {
                show: false,
                formatter: (params) => {
                  // value为0或空时不显示label
                  if (!params.value || Number(params.value) === 0) return ''
                  return `${params.name}: ${this.$tools.momenyFormat(
                    params.value,
                    2
                  )} (${params.percent}%)`
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
              },
            },
          ],
        }
        myChart.setOption(option)
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const moneyFields = [
        'ElectricityAmount',
        'WaterAmount',
        'GasAmount',
        'SubTotal',
        'AmortizationAmount',
        'OutsourcingAmount',
        'ToTalAmount',
      ]
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计\r小计'
          return
        }
        if (moneyFields.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]))
          sums[index] = this.$tools.momenyFormat(
            values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0),
            2
          )
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    getSubtotal(field) {
      // 当前页小计
      return this.tableData.reduce((sum, row) => {
        const val = Number(row[field])
        return sum + (isNaN(val) ? 0 : val)
      }, 0)
    },
  },
  mounted() {
    // this.searchYearMonth = [moment().format("YYYYMM"), moment().format("YYYYMM")];
    // this.getDataList();
  },
  beforeDestroy() {
    // 清理所有图表实例
    const dom = document.querySelector('.tab-chart-container')
    if (dom && dom.__echarts__) {
      dom.__echarts__.dispose()
    }

    // 清理饼图实例
    this.monthChartData.forEach((_, index) => {
      const pieDom = document.getElementById(`pie-chart-${index}`)
      if (pieDom && pieDom.__echarts__) {
        pieDom.__echarts__.dispose()
      }
    })
  },
  created() {
    this.searchYearMonth = [
      moment().format('YYYYMM'),
      moment().format('YYYYMM'),
    ]
    // this.getDataList();
    this.getEchartsData()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    devTreeSearch() {
      if (this.activeName === 'CostEcharts') {
        this.chartData = []
        this.monthChartData = []
        this.getEchartsData()
      } else {
        this.getDataList()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  height: calc(100%);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
.tab-chart-container {
  width: 100%;
  height: 300px;
  min-height: 200px;
  box-sizing: border-box;
}
.tab-chart-pieList {
  width: 100%;
  height: 200px;
  min-height: 150px;
  box-sizing: border-box;
}
.pie-charts-container {
  display: flex;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: repeat(4, 1fr);
  // grid-template-rows: repeat(3, 1fr);
  // gap: 10px;
  // height: 100%;
  // padding: 10px;
}
.pie-chart-item {
  width: calc(100% / 12);
  min-width: 80px;
  height: 100%;
  border-right: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}
.pie-chart-item:last-child {
  border-right: none;
}
@media (max-width: 1200px) {
  .pie-chart-item {
    width: calc(100% / 6);
  }
}
@media (max-width: 800px) {
  .pie-chart-item {
    width: calc(100% / 3);
  }
  .tab-chart-container {
    height: 220px;
  }
  .tab-chart-pieList {
    height: 120px;
  }
}
.no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #999;
  font-size: 12px;
}
.no-data-container {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}
::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
.custom-subtotal-row {
  display: flex;
  align-items: center;
  border-top: 1px solid #ebeef5;
  background: #fafafa;
  font-weight: bold;
  font-size: 14px;
  min-height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
}
.subtotal-cell {
  display: inline-block;
  text-align: center;
  border-right: 1px solid #ebeef5;
  padding: 0 8px;
  height: 40px;
  line-height: 40px;
}
.chart-card {
  margin-bottom: 16px;
}
::v-deep .el-card__header {
  font-weight: bold;
}
</style>
